export default __webpack_public_path__ + "static/video-poster-205511b0ee6c21289bff21cdd753c954.jpeg";